import { render, staticRenderFns } from "./teacherLeaveDeptForm.vue?vue&type=template&id=5cfa908f&scoped=true&"
import script from "./teacherLeaveDeptForm.vue?vue&type=script&lang=js&"
export * from "./teacherLeaveDeptForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherLeaveDeptForm.vue?vue&type=style&index=0&id=5cfa908f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa908f",
  null
  
)

export default component.exports